import {
  Box,
  Fade,
  Slide,
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { CustomIcons } from 'modules/components/layer00';
import React, {
  useEffect,
  useState
} from 'react';



export type ChatBubbleProps = {
  role: 'SHERLOCK' | 'USER';
  sentTimestamp?: DateTime;
  text: React.ReactNode;
  slideRef?: React.MutableRefObject<HTMLDivElement | null>;
  variant?: 'chat' | 'info';
};

export const FC = (props: ChatBubbleProps) => {
  const [
    open,
    setOpen
  ] = useState(props.slideRef ? false : true);

  useEffect(() => {
    if (props.slideRef) {
      setOpen(!_.isNil(props.slideRef.current));
    }
  }, [props.slideRef]);

  const content = (
    <Box
      paddingRight={props.role === 'SHERLOCK' ? '1rem' : '0rem'}
      paddingLeft={props.role !== 'SHERLOCK' ? '1rem' : '0rem'}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        paddingBottom='.25rem'
        paddingRight='.5rem'
      >
        <Typography
          variant='chatMessageTitle'
          sx={{
            color: (theme) => props.variant === 'info' ? theme.palette.gray['light60'] : undefined
          }}
        >
          {props.role === 'SHERLOCK' ? 'Sherlock' : 'User'}
        </Typography>

        {props.sentTimestamp && (
          <Typography
            variant='chatMessageTitle'
          >
            {props.sentTimestamp.toFormat('MM/dd/yyyy @ hh:mma')}
          </Typography>
        )}
      </Stack>

      {/* Message bubble */}
      <Stack
        padding='1rem 1rem 1rem 0.75rem'
        sx={{
          minWidth: 300,
          display: 'inline-block',
          borderRadius: '0rem 1rem 1rem 1rem',
          backgroundColor: (theme) => {
            if (props.variant === 'info') {
              return theme.palette.primary.darker140;
            }

            return props.role === 'USER'
              ? theme.palette.primary.darker200
              : theme.palette.primary.darker140;

          }
        }}
      >
        <Stack direction='row' flex='1 1 0'>
          <Box>
            <CustomIcons.LargeIcon.FC
              height='1rem'
              width='1rem'
              icon='MAGNIFYINGGLASS'
            />
          </Box>

          <Typography
            marginLeft='.75rem'
            textOverflow='ellipsis'
            variant='chatMessageBody'
            sx={{
              whiteSpace: 'pre-line'
            }}
          >
            {props.text}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );

  if (!props.slideRef) {
    return content;
  }

  return (
    <Slide
      mountOnEnter
      unmountOnExit
      in={open}
      direction='up'
      container={props.slideRef.current}
    >
      <div>
        <Fade
          in={open}
          timeout={1500}

        >
          <div>
            {content}
          </div>
        </Fade>
      </div>
    </Slide>
  );
};
